'use strict';

import calendarWrapper from './calendar-wrapper.js';

const MODULE_NAME = 'daupler.entities.calendar';

var app = angular.module(MODULE_NAME, [
]);
app.directive('calendarWrapper', calendarWrapper);

export default MODULE_NAME;
